import React, { FunctionComponent, useState } from 'react'
import { Button, Card, Col, Row } from 'antd'
import { useLoaderData, useNavigate } from '@tanstack/react-router'
import FeathersServiceStatistic from '../../components/FeathersServiceStatistic/FeathersServiceStatistic'
import ActiveUsers from './ActiveUsers/ActiveUsers'

interface Item {
  key: string
  name: string
  body?: any
  description?: string
  actions?: any[]
}

const Admin: FunctionComponent<any> = () => {
  const { agencyIds } = useLoaderData({ from: '/admin/_layout' })

  const navigate = useNavigate()

  const [loading, setLoading] = useState<string | undefined>()

  const items: Item[] = [
    {
      key: '/admin/access',
      name: 'Access Codes',
      body: (
        <Row>
          <Col span={12}>
            <FeathersServiceStatistic
              serviceName={'assettrak-access'}
              title={'Active (24h)'}
              query={{
                last_login: {
                  $gte: new Date(new Date().getTime() - 1000 * 60 * 60 * 24)
                }
              }}
            />
          </Col>
          <Col span={12}>
            <FeathersServiceStatistic serviceName={'assettrak-access'} title={'Total'} />
          </Col>
        </Row>
      ),
      description: 'Manage user access',
      actions: [
        {
          key: '/admin/access',
          name: 'List'
        }
      ]
    },
    {
      key: '/admin/devices',
      name: 'Devices',
      body: (
        <Row>
          <Col span={12}>
            <FeathersServiceStatistic
              serviceName={'vehicle-location'}
              title={'Active (24h)'}
              query={{
                update_received: {
                  $gte: new Date(new Date().getTime() - 1000 * 60 * 60 * 24)
                }
              }}
            />
          </Col>
          <Col span={12}>
            <FeathersServiceStatistic serviceName={'vehicle'} title={'Total'} />
          </Col>
        </Row>
      ),
      description: 'Manage vehicles',
      actions: [
        {
          key: '/admin/devices',
          name: 'List'
        }
      ]
    },
    {
      key: '/admin/agencies',
      name: 'Agencies',
      body: (
        <FeathersServiceStatistic
          serviceName={'agencies'}
          title={'Total'}
          query={{ id: { $in: agencyIds } }}
        />
      ),
      description: 'Manage agencies',
      actions: [
        {
          key: '/admin/agencies',
          name: 'List'
        }
      ]
    }
  ]

  const handleAction = async (action: any) => {
    setLoading(action.key)
    await navigate({ to: action.key }).then(() => setLoading(undefined))
  }

  return (
    <>
      <Row style={{ margin: '24px' }} gutter={[12, 12]} justify={'center'}>
        {items.map((item: Item) => (
          <Col key={item.key} span={6}>
            <Card
              variant={'outlined'}
              title={item.name}
              actions={item.actions?.map((action: any) => (
                <Button
                  loading={loading === action.key}
                  disabled={!!loading}
                  key={action.key}
                  onClick={() => handleAction(action)}
                >
                  {action.name}
                </Button>
              ))}
            >
              {item.body}
            </Card>
          </Col>
        ))}
      </Row>
      <Row style={{ margin: '24px' }} gutter={[12, 12]} justify={'center'}>
        <ActiveUsers />
      </Row>
    </>
  )
}

export default Admin
